import { TicketListItemModel } from "@jugl-web/rest-api/tickets/models/TicketListItem";
import { TableCell } from "@jugl-web/ui-kit";
import { useClientSupportPageContext } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/ClientSupportPageProvider/useClientSupportPageContext";
import { FC } from "react";
import { ReactComponent as InactiveIcon } from "./assets/inactive.svg";

interface TeamNotesCellContentProps {
  ticket: TicketListItemModel;
}

export const TeamNotesCellContent: FC<TeamNotesCellContentProps> = ({
  ticket,
}) => {
  const { openTicketDetailsSidebar } = useClientSupportPageContext();

  return (
    <TableCell
      classNames={{ content: "text-center" }}
      onClick={() => openTicketDetailsSidebar(ticket.id, "team-notes")}
    >
      <InactiveIcon className="shrink-0" />
    </TableCell>
  );
};
